module.exports = __webpack_public_path__ + "static/media/Logo1.b465d972.png";